import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './dialog';
import { useUnsavedGuard } from '../../hooks/useUnsavedGuard';
import { cn } from '../../lib/utils';

// Contenedor generico anterior a shadcn; hoy solo lo usan subir y recortar foto
// (PhotoUploadModal -> CropImageModal), que se abren desde el telefono. Conserva su API
// (isOpen, onClose, title, size, guardOnClose, isDirty) pero desde 2026-09-05 se pinta
// sobre el Dialog de la base: era un portal a mano y no heredaba la pantalla completa
// en telefono ni el tema.

const SIZE = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
};

const CustomModal = ({
  isOpen,
  onClose,
  children,
  title,
  className = '',
  size = 'md',
  guardOnClose = false,
  isDirty = false
}) => {
  const guard = useUnsavedGuard({ onClose });

  useEffect(() => {
    if (isDirty) guard.markDirty();
  }, [isDirty]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!isOpen) guard.resetDirty();
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClose = () => {
    if (guardOnClose && isDirty) {
      guard.onOpenChange(false);
    } else if (onClose) {
      onClose();
    }
  };

  return (
    <>
      <Dialog open={Boolean(isOpen)} onOpenChange={(open) => { if (!open) handleClose(); }}>
        <DialogContent className={cn(SIZE[size] || SIZE.md, className)}>
          {title ? (
            <DialogHeader>
              <DialogTitle className="text-left font-display">{title}</DialogTitle>
            </DialogHeader>
          ) : (
            <DialogTitle className="sr-only">Ventana</DialogTitle>
          )}
          <div className="min-h-0">
            {children}
          </div>
        </DialogContent>
      </Dialog>
      {guard.DiscardDialog}
    </>
  );
};

export default CustomModal;
